import React from "react"
import { C } from "@/theme/newDesignTokens"

const getCheckboxStyle = (checked: boolean, indeterminate: boolean, size: number): React.CSSProperties => ({
    width: size,
    height: size,
    borderRadius: 3,
    flexShrink: 0,
    cursor: "pointer",
    border: `1.5px solid ${checked || indeterminate ? C.navy : C.lightGray}`,
    background: checked ? C.navy : C.white,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.15s",
})

interface ChkProps {
    checked: boolean
    onChange: (checked: boolean) => void
    size?: number
    indeterminate?: boolean
}

/** Custom checkbox matching the new design system. */
export const Chk: React.FC<ChkProps> = ({ checked, onChange, size = 14, indeterminate = false }) => (
    <span
        role="checkbox"
        aria-checked={indeterminate ? "mixed" : checked}
        tabIndex={0}
        onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            onChange(!checked)
        }}
        onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault()
                onChange(!checked)
            }
        }}
        style={getCheckboxStyle(checked, indeterminate, size)}
    >
        {checked && (
            <svg width={size - 4} height={size - 4} viewBox="0 0 10 10" fill="none">
                <path
                    d="M2 5.5L4.2 7.5L8 3"
                    stroke="#fff"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        )}
        {!checked && indeterminate && (
            <svg width={size - 4} height={size - 4} viewBox="0 0 10 10" fill="none">
                <path d="M2 5H8" stroke={C.navy} strokeWidth="1.8" strokeLinecap="round" />
            </svg>
        )}
    </span>
)
